import { useDispatch, useSelector } from "react-redux"
import styled from "styled-components"
import Button from "../../shared/button/Btn"
import { showModal } from "../../../features/modal/modalSlice"
import { useLocation } from "react-router-dom"
import { useScrollLock } from "../../../hooks/useScrollLock"
import { useEffect, useState } from "react"
import PageTopTitle from "../../shared/PageTopTitle"
import { getCompanyVergiNo } from "../../../features/isOrtaklari/isOrtaklariSlice"
import { handleActiveSelect } from "../../../features/layout/layoutSlice"
import MatchNewProject from "../../companyProjectForms/MatchNewProject"
import AddNewLoadGiver from "../../companyProjectForms/AddNewLoadGiver"
import InputNumberNew from "../../shared/input/new/InputNumberNew"

const Container = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: rgba(0,0,0,0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;

    .modal{
        width: 700px;
        height: auto;
        color: ${({ theme }) => theme.mainTextColor};
        background-color: ${({ theme }) => theme.mainBgColor};
        padding-block: 20px;
        border-radius: 10px;
        .form-container{
            padding: 20px;
            width: 70%;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            gap: 20px;
            .query-side{
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 2px solid;
                border-color: ${({ theme }) => theme.mainBorderColor};
                padding-bottom: 20px;
                gap: 10px;
                .btn-container{
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }
                .input-grp{
                    width: 100%;
                }
            }
        }
        
    }
    .error{
        font-size: 12px;
        color: var(--color-main);
        font-weight: var(--font-weight-lg);
    }
`

    
const ProjeOlusturModal = () => {

    const {modalLocation } = useSelector(state => state.modal)
    const { searchCompany, isSearchCompany } = useSelector(state => state.isOrtaklari)
    const dispatch = useDispatch()
    const location = useLocation()
    const { lockScroll, unlockScroll } = useScrollLock();
    const [search, setSearch] = useState("")

    //! bu modal açıldığnda ekran ı lock lamak için
    useEffect(() => {
    lockScroll()

    return () => {
        unlockScroll()
    }
    }, [lockScroll, unlockScroll])

    //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
    useEffect(() => {
        if (location.pathname !== modalLocation) {
            dispatch(showModal(null))
        }
    }, [dispatch, location.pathname, modalLocation])

  return (
    <Container onClick={() => dispatch(showModal(null))}>
        <div className="modal" onClick={(e)=> {e.stopPropagation(); dispatch(handleActiveSelect(null)) }}>
            <PageTopTitle isDiffPage title={"Proje Oluştur"} />
            <div className="form-container">
                <div className="query-side">
                    <div className="input-grp">
                        <InputNumberNew max={11} data={search} setData={(e) => setSearch(e.target.value)} labelText="Vergi No" inputWidth={"100%"} name={"search"}/>
                    </div>
                    <div className="btn-container">
                        <Button width="100px" handleClick={()=> dispatch(getCompanyVergiNo(search))} padding="10px" background="#fff" color={"#E85446"}>Sorgula</Button>
                    </div>
                </div>
                
                {searchCompany?.id && 
                    <MatchNewProject />
                }

                {!searchCompany?.id && isSearchCompany &&
                    <AddNewLoadGiver />
                }
            </div>
            
        </div>
    </Container>
  )
}

export default ProjeOlusturModal